import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"

const ThemeModal = ({
  isOpen = false,
  toggle = () => {},
  title = "",
  children,
  footer = null,
  centered = true,
  backdrop = "static",
  keyboard = false,
  size = "md", // optional: sm, md, lg, xl
  modalBodyClass = "",
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered={centered}
      backdrop={backdrop}
      keyboard={keyboard}
      size={size}
    >
      {title && <ModalHeader toggle={toggle}>{title}</ModalHeader>}
      <ModalBody className={modalBodyClass}>{children}</ModalBody>
      {footer && <ModalFooter>{footer}</ModalFooter>}
    </Modal>
  )
}

export default ThemeModal
